export const initialStates = {
  func: {
    handleSave: () => {},
    handleRevise: () => {},
    handleReviseAndDecide: () => {},
    handleEditStateTrigger: () => {},
  },
  states: {
    editTrigger: {
      trigger: false,
      mediaID: null,
      groupId: null,
    },
  },
};
